import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';
import {Injectable} from '@angular/core';
import { Magasin } from './magasin.model';

@Injectable({
  providedIn: 'root'
})
export class MagasinService extends DaoGeneric<Magasin> {
  private url = `${environment.baseUrl}/api_archive/magasin/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }


}
